import { adminGet } from '../api';
import type { EntitlementDiagnosticsData } from './types';

export const entitlementAdminApi = {
    get: (studentId: string) => adminGet<EntitlementDiagnosticsData>(`/admin/mobile/accounts/${encodeURIComponent(studentId)}/entitlements`),
};
